import getPageName from "./getPageName";
import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Navigation, Pagination]);

const coaching = () => {
  if (getPageName() != "coaching") return;

  const tabs = document.querySelectorAll(".coaching-reviews__tab"),
    sliders = document.querySelectorAll(".coaching-reviews__slider");

  // Начальные параметры
  let activeTab = document.querySelector(".coaching-reviews__tab.active");
  let activeSlider = sliders[0];
  activeSlider.style.display = "block";
  initSlider(activeSlider);

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      if (!tab.classList.contains("active")) {
        activeTab.classList.remove("active");
        tab.classList.add("active");

        activeSlider.style.display = "none";
        initSlider(sliders[index]);
        sliders[index].style.display = "block";

        activeTab = tab;
        activeSlider = sliders[index];
      }
    });
  });

  function initSlider(slider) {
    slider &&
      new Swiper(slider, {
        loop: false,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 3
          },
          500: {
            slidesPerView: 2
          },
          0: {
            slidesPerView: 1
          },
        },
        navigation: {
          nextEl: ".coaching-reviews__slider-next",
          prevEl: ".coaching-reviews__slider-prev",
          disabledClass: "last",
        },
        pagination: {
          el: ".coaching-reviews__slider-pagination",
          bulletActiveClass: "active",
          clickable: true,
        },
      });
  }

  (() => {
    const contents = document.querySelectorAll(".coaching-reviews__slider-item p");
    const btns = document.querySelectorAll(".coaching-reviews__slider-item__btn");

    btns.forEach((item, index) => {
      item.addEventListener("click", () => {
        if (contents[index].getAttribute("aria-hidden") == "false") {
          contents[index].setAttribute("aria-hidden", "true");
          contents[index].classList.add("hide");
          btns[index].textContent = "Читать далее";
        } else {
          contents[index].setAttribute("aria-hidden", "false");
          contents[index].classList.remove("hide");
          btns[index].textContent = "Свернуть";
        }
      });
    });
  })();
};

export default coaching;
